require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-access-to-information-is-the-ifc-leaving-communities.json") })
        }
      }, "path---en-us-update-access-to-information-is-the-ifc-leaving-communities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-access-to-information-is-the-ifc-leaving-communities!./.cache/json/en-us-update-access-to-information-is-the-ifc-leaving-communities.json
// module id = 603
// module chunks = 231608221292675